"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exportToExcel;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _downloadjs = _interopRequireDefault(require("downloadjs"));
var _exceljs = _interopRequireDefault(require("exceljs/dist/exceljs"));
var _excelExportFormatter = _interopRequireWildcard(require("./excelExportFormatter"));
var _excluded = ["children"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function getValueByPath(data, path) {
  var value;
  if (!data || !path) return value;
  if (path.includes('.')) value = path.split('.').reduce(function (parent, prop) {
    return parent ? parent[prop] : undefined;
  }, data);else value = data[path];
  return value;
}
function bufferToBlob(buf) {
  if (!buf || !buf.length) return undefined;
  try {
    var blob = new Blob([buf]);
    return blob;
  } catch (err) {
    var ab = new ArrayBuffer(buf.length);
    var uintArray = new Uint8Array(ab);
    for (var i = 0; i < buf.length; ++i) {
      uintArray[i] = buf[i];
    }
    var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
    var bb = new BlobBuilder();
    bb.append(ab);
    var _blob = bb.getBlob();
    return _blob;
  }
}
function getValueByType(dataRow, col) {
  var value = getValueByPath(dataRow, col.dataIndex);
  if (col.excelRender && typeof col.excelRender === 'function') return col.excelRender(value);
  switch (col.type) {
    case _excelExportFormatter.InputTypes.currency:
      // col => { currencyType, currencyPrecision, allowEmpty, removeTrailingZeros }
      return _excelExportFormatter.default.currency(_objectSpread(_objectSpread({}, col), {}, {
        value: value
      }));
    case _excelExportFormatter.InputTypes.date:
      return _excelExportFormatter.default.date(value, col.format);
    case _excelExportFormatter.InputTypes.datetime:
      return _excelExportFormatter.default.date(value, col.format);
    case _excelExportFormatter.InputTypes.iban:
      return _excelExportFormatter.default.iban(value);
    case _excelExportFormatter.InputTypes.jsondate:
      return _excelExportFormatter.default.jsondate(value, col.format);
    case _excelExportFormatter.InputTypes.moment:
      return _excelExportFormatter.default.moment(value, col.format);
    case _excelExportFormatter.InputTypes.timestamp:
      return _excelExportFormatter.default.timestamp(value, col.format);
    case _excelExportFormatter.InputTypes.number:
      return String(value);
    default:
      return !!value || value === 0 ? String(value) : "";
  }
}

/* Excel Helper Methods */
function prepareColumns(columns) {
  var filteredCols = columns.map(function (column) {
    // beforeDownload methodundan getColumn fonskiyonu ile yakalanıp sonradan style değiştirilebilmesi için için key ve header alanları eklendi 
    column.key = column.key || column.dataIndex;
    column.header = column.title;
    return column;
  }).filter(function (column) {
    return column.title && column.dataIndex;
  });
  var header = filteredCols.map(function (column) {
    if (column.title && typeof column.title !== 'string' || column.excelTitle && typeof column.excelTitle === 'string') {
      return column.excelTitle ? column.excelTitle : '';
    }
    return column.title;
  });
  return {
    filteredCols: filteredCols,
    header: header
  };
}
function prepareExcelHeaderStyle(row, filteredCols) {
  row.font = {
    bold: true,
    size: 12
  };
  row.height = 20;
  row.alignment = {
    vertical: 'middle',
    horizontal: 'center'
  };
  var headerBorderStyles = {
    top: {
      style: 'thin'
    },
    left: {
      style: 'thin'
    },
    bottom: {
      style: 'medium'
    },
    right: {
      style: 'thin'
    }
  };
  row.eachCell(function (cell, index) {
    cell.border = headerBorderStyles;
    var selectedCell = filteredCols[index - 1];
    var headerStyle = selectedCell.excelExport && selectedCell.excelExport.headerStyle || {};
    var preparedFillProp = prepareFillProp(headerStyle);
    var preparedFontProp = prepareFontProp(headerStyle);
    cell.fill = preparedFillProp;
    cell.font = preparedFontProp;
    return cell;
  });
}
function prepareExcelHeader(workSheet, header, filteredCols) {
  var row = workSheet.addRow(header);
  prepareExcelHeaderStyle(row, filteredCols);
}
function flatten(array) {
  return array.flatMap(function (_ref) {
    var children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    return [_objectSpread({}, rest)].concat((0, _toConsumableArray2.default)(flatten(children || [])));
  });
}
function prepareExcelBodyData(data, filteredCols) {
  var preparedData = flatten(data);
  var rows = preparedData.map(function (dataRow) {
    var mappedValue = filteredCols.map(function (col) {
      var val = getValueByType(dataRow, col);
      return val;
    });
    return mappedValue;
  });
  return rows;
}
function prepareExcelBody(ws, data, filteredCols) {
  var rows = prepareExcelBodyData(data, filteredCols);
  ws.addRows(rows);
}
function prepareColumnStyles(ws, filteredCols) {
  var dataBorderStyles = {
    top: {
      style: 'thin'
    },
    left: {
      style: 'thin'
    },
    bottom: {
      style: 'thin'
    },
    right: {
      style: 'thin'
    }
  };
  ws.eachRow(function (row, rowNumber) {
    if (rowNumber === 1) {
      // başlığı atlayalım
      return;
    }
    row.eachCell(function (cell, index) {
      // index started 1,
      cell.border = dataBorderStyles;
      var selectedCell = filteredCols[index - 1];
      var contentStyle = selectedCell.excelExport && selectedCell.excelExport.contentStyle || {};
      var preparedFillProp = prepareFillProp(contentStyle);
      var preparedFontProp = prepareFontProp(contentStyle);
      cell.font = preparedFontProp;
      cell.fill = preparedFillProp;
      return cell;
    });
  });
}
function colorMethodByUserLogic(ws, filteredCols) {
  // beforeDownload methodundan getColumn fonskiyonu ile yakalanıp sonradan style değiştirilebilmesi için  columns tanımalası yapıldı.
  // aşağıdaki alan olmadan ws.getColumn(dataIndex); şeklinde bir kullanım olamaz.
  ws.columns = filteredCols;
  filteredCols.map(function (filteredCol) {
    if (filteredCol.excelExport && typeof filteredCol.excelExport.beforeDownload == "function") {
      var dataIndex = filteredCol.dataIndex;
      var cells = ws.getColumn(dataIndex);
      filteredCol.excelExport.beforeDownload(cells, ws);
    }
  });
}
function prepareFontProp(style) {
  var _style = style || {};
  return {
    size: _style.size,
    name: _style.name,
    family: _style.family,
    bold: _style.bold,
    italic: _style.italic,
    underline: _style.underline,
    strike: _style.strike,
    outline: _style.outline,
    vertAlign: _style.vertAlign,
    color: {
      argb: _style.color && _style.color.replace('#', '')
    }
  };
}
function prepareFillProp(style) {
  var _style = style || {};
  return {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {
      argb: _style.fgColor && _style.fgColor.replace('#', '')
    },
    bgColor: {
      argb: _style.bgColor && _style.bgColor.replace('#', '')
    }
  };
}
function excelAutowidth(ws) {
  for (var i = 0; i < ws.columns.length; i += 1) {
    var dataMax = 0;
    var col = ws.columns[i];
    for (var j = 1; j < col.values.length; j += 1) {
      var val = col.values[j];
      if (typeof col.values[j] === 'number') val = col.values[j].toString();
      var columnLength = val ? val.length : 0;
      if (columnLength > dataMax) {
        dataMax = columnLength;
      }
    }
    col.width = dataMax < 10 ? 14 : dataMax + 4;
  }
}
function writeBufferAndDownload(wb, fileName) {
  return wb.xlsx.writeBuffer().then(function (buf) {
    var blob = bufferToBlob(buf);
    if (!blob) {
      Promise.reject('Error creating blob.');
      return false;
    }
    var result = (0, _downloadjs.default)(blob, "".concat(fileName, ".xlsx"), 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    if (result === false) {
      Promise.reject('Error downloading generated file.');
    }
    return result;
  });
}
/* Excel Helper Methods */

/**
 * ykb-ui/table componentinde gösterilen veriyi excel'e aktarır. Sadece title ve dataIndex alanları tanımlı olan column'lar dışa aktarılır.
 * @param {Object} options - Export options
 * @param {Object[]} options.columns - Excel column titles
 * @param {Object[]} options.data - Excel data
 * @param {string} options.fileName - Exported file name
 * @param {string} options.beforeDownload - Exported file name
 */
function exportToExcel(options) {
  var columns = options.columns,
    data = options.data,
    _options$fileName = options.fileName,
    fileName = _options$fileName === void 0 ? 'export' : _options$fileName,
    filename = options.filename;
  try {
    var _prepareColumns = prepareColumns(columns),
      filteredCols = _prepareColumns.filteredCols,
      header = _prepareColumns.header;
    var wb = new _exceljs.default.Workbook();
    var ws = wb.addWorksheet();

    // başlık ayarları, excelin ilk satırı
    prepareExcelHeader(ws, header, filteredCols);

    // verinin excel satırı olarak eklenmesi
    prepareExcelBody(ws, data, filteredCols);

    // verilerin bulunduğu hücrelerin stilleri
    prepareColumnStyles(ws, filteredCols);

    // sonradan belirli hücre aralıklarını manuel olarak, 
    // bir logic işleme göre renklendirmek isterse
    colorMethodByUserLogic(ws, filteredCols);

    // autowidth özelliği, sütun genişliklerini veri uzunluğuna göre ayarlar
    excelAutowidth(ws);
  } catch (err) {
    return Promise.reject(err);
  }
  var excelFileName = filename || fileName;
  return writeBufferAndDownload(wb, excelFileName);
}